import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from "@ngx-translate/core";
import { BarChartRendererComponent } from './bar-chart-renderer.component';
import { BarChartModule } from '@shared/components/bar-chart/bar-chart.module';

@NgModule({
  declarations: [ BarChartRendererComponent ],
  exports: [ BarChartRendererComponent ],
  imports: [
    CommonModule,
    BarChartModule
  ],
  providers: [
    TranslatePipe
  ]
})
export class BarChartRendererModule { }
